<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">办公系统</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/workflow/flowArticle' }">发文管理</el-breadcrumb-item>
        <el-breadcrumb-item>编辑推文</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="article-pusher">
        <el-form :model="formData" label-width="120px">
            <el-form-item label="标题">
                <el-select v-model="formData.articleType" placeholder="请选择发文栏目"
                    style="width: 180px; margin-right: 10px;">
                    <el-option label="推荐" value="推荐">
                        <span style="float: left">推荐</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            推荐文章
                        </span>
                    </el-option>
                    <el-option label="热门" value="热门">
                        <span style="float: left">热门</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            热门文章
                        </span>
                    </el-option>
                    <el-option label="公告" value="公告">
                        <span style="float: left">公告</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            公司通告
                        </span>
                    </el-option>
                    <el-option label="通知" value="通知">
                        <span style="float: left">通知</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            公共通知
                        </span>
                    </el-option>
                    <el-option label="月刊" value="月刊">
                        <span style="float: left">月刊</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            内部月刊
                        </span>
                    </el-option>
                    <el-option label="指引" value="指引">
                        <span style="float: left">指引</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            系统操作指引
                        </span>
                    </el-option>
                </el-select>
                <el-input v-model="formData.title" placeholder="请输入文章标题" style="max-width: 60%;" />
            </el-form-item>

            <el-form-item label="副标题">
                <el-input v-model="formData.subTitle" placeholder="请输入副标题" style="max-width: 60%;" />
            </el-form-item>

            <el-form-item label="部门及发布人">
                <el-input v-model="formData.publishDeptName" placeholder="部门名称"
                    style="max-width: 130px; margin-right: 12px;" />
                <el-input v-model="formData.publishUserName" placeholder="发布人姓名" style="max-width: 220px;" />
            </el-form-item>

            <el-form-item label="附件上传">
                <div style="width: 100%;">
                    <el-upload :action="uploadAction" list-type="picture-card" :on-success="uploadHandleSuccess"
                        :on-preview="previewHandle" :before-upload="uploadHandleBefore" :file-list="fileList"
                        accept="*/*">
                        <el-icon>
                            <Plus />
                        </el-icon>
                        <template #file="{ file }">
                            <div>
                                <img v-if="file.ext === 'jpg' || file.ext === 'jpeg' || file.ext === 'png' || file.ext === 'bmp'"
                                    class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                                <div v-else
                                    style="font-size: 1em; width: 100%; text-align: center; font-weight: 800; display: flex; align-items: center; padding: 10px;">
                                    <span style="overflow-wrap: anywhere;">{{ file.name }}</span>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="previewHandle(file)" title="预览">
                                        <el-icon>
                                            <ZoomIn />
                                        </el-icon>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="downloadHandle(file)" title="下载">
                                        <el-icon>
                                            <Download />
                                        </el-icon>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="removeHandle(file)" title="删除">
                                        <el-icon>
                                            <Delete />
                                        </el-icon>
                                    </span>
                                </span>
                            </div>
                        </template>
                    </el-upload>
                </div>
            </el-form-item>


            <el-form-item label="正文内容">
                <div style="border: 1px solid #ccc; width: 100%;">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig"
                        :mode="mode" />
                    <Editor style="height: 400px; overflow-y: hidden;" v-model="formData.content"
                        :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" />
                </div>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSubmit()">保存</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { shallowRef } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue'
import util from '@/utils/util'
import kaung from '@/utils/kaung.js'
import { fetchFileList, delFile } from '@/api/basic'

export default {
    name: "FlowArticlePusher",
    components: {
        Editor,
        Toolbar,
        Plus,
        ZoomIn,
        Download,
        Delete
    },
    data() {
        return {
            editorRef: shallowRef(),
            mode: 'default',
            id: null,
            formData: {
                title: '',
                subTitle: '',
                publishDeptName: '',
                publishUserName: '',
                content: '',
                uniqueCode: '',
                id: ''
            },
            fileList: [],
            toolbarConfig: {
                excludeKeys: [
                    'group-image',
                    'group-video',
                    'uploadImage',
                    'insertImage',
                    'uploadVideo',
                    'insertVideo'
                ]
            },
            editorConfig: {
                placeholder: '请输入文章正文内容...',
                MENU_CONF: {},
                // 添加错误处理配置
                onError: (err) => {
                    console.warn('Editor error:', err)
                }
            }
        }
    },
    computed: {
        apiUrl() {
            return process.env.VUE_APP_BASEURL
        },
        uploadAction() {
            return `${this.apiUrl}BaseUploader/Basic?dataType=FlowArticle&dataID=${this.formData.uniqueCode || this.formData.id || ''}&fileType=form&fileCode=${this.formData.uniqueCode || this.formData.id || ''}`
        }
    },
    mounted() {
        this.$kaung = kaung.init('FlowArticle');
        this.handleReset();
        this.handleLoad();
    },
    beforeUnmount() {
        const editor = this.editorRef
        if (editor == null) return
        try {
            editor.destroy()
        } catch (e) {
            console.warn('Editor destroy error:', e)
        }
    },
    methods: {
        handleCreated(editor) {
            this.editorRef = editor
            // 编辑器创建后，设置初始内容（避免空内容导致的错误）
            if (!this.formData.content) {
                editor.dangerouslyInsertHtml('<p><br></p>')
            }
        },
        handleReset() {
            this.formData = {
                title: '',
                subTitle: '',
                publishDeptName: '',
                publishUserName: '',
                content: '',
                uniqueCode: '', //util.getUUID(16, 36),
                id: ''
            }
            this.fileList = []

            // 重置编辑器内容
            if (this.editorRef) {
                try {
                    this.editorRef.clear()
                    // 设置一个空段落，避免完全为空导致错误
                    this.editorRef.dangerouslyInsertHtml('<p><br></p>')
                } catch (e) {
                    console.warn('Editor reset error:', e)
                }
            }

            console.log(this.formData)
        },
        handleSubmit() {
            if (!this.formData.title) {
                this.$kaung.message('请输入标题')
                return
            }
            if (!this.formData.content) {
                this.$kaung.message('请输入正文内容')
                return
            }

            // 同步附件路径数组到 attachments 字段
            if (this.fileList && this.fileList.length > 0) {
                this.formData.attachments = this.fileList.map(file => file.url || file.response?.data?.url || '').filter(url => url).join(';')
            } else {
                this.formData.attachments = ''
            }

            kaung.post({
                url: '/FlowArticle/' + (this.id || ''),
                method: this.id ? 'put' : 'post',
                data: this.formData
            }).then((res) => {
                if (res.code === 200) {
                    this.formData = { ...this.formData, ...res.data };
                    kaung.success(res.content || '操作成功');
                    this.$router.back();
                } else {
                    kaung.error(res.content || '操作失败')
                }
            }).catch((error) => {
                kaung.error(error.message || '操作失败')
            })
        },
        // 获取附件列表
        getFileList() {
            const dataID = this.formData.uniqueCode || this.formData.id
            console.log('dataID', dataID)
            if (!dataID) return

            fetchFileList(dataID).then((res) => {
                if (res.code === 200) {
                    this.fileList = res.data || []
                }
            })
        },
        // 上传前检查
        uploadHandleBefore(file) {
            if (!this.formData.uniqueCode && !this.formData.id) {
                this.$message.warning('请先保存文章后再上传附件')
                return false
            }
            return true
        },
        // 上传成功
        uploadHandleSuccess(res, file, uploadFileList) {
            if (res.code === 200) {
                this.$message.success(res.content || '上传成功')
                this.getFileList()
            } else {
                this.$message.error(res.content || '上传失败')
            }
        },
        // 预览文件
        previewHandle(file) {
            window.open('/preview?id=' + file.id)
        },
        // 下载文件
        downloadHandle(file) {
            window.open(file.url)
        },
        // 删除文件
        removeHandle(file) {
            const userInfo = this.$store.state.userInfo
            const role = userInfo.roles?.filter(x => x.toLowerCase() === 'admin') || []

            this.$confirm('确定要删除该附件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(file.id).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(res.content || '删除成功')
                        this.getFileList()
                    } else {
                        this.$message.error(res.content || '删除失败')
                    }
                })
            }).catch(() => { })
        },
        handleLoad() {
            this.id = this.$route.query.id;
            if (!this.id) {
                this.$kaung.getid().then((res) => {
                    if (res.code === 200) {
                        this.formData.id = res.data;
                        this.formData.uniqueCode = res.data;
                        // 获取到 uniqueCode 后立即加载附件列表
                        this.getFileList();
                    } else {
                        kaung.error(res.content || '获取ID失败')
                    }
                }).catch((error) => {
                    kaung.error(error.message || '获取ID失败')
                });

                return;
            }

            console.log(this.id)

            kaung.fetch({
                url: '/FlowArticle/' + this.id,
                method: 'get'
            }).then((res) => {
                this.formData = { ...this.formData, ...res.data };
                console.log('formData', this.formData)
                this.getFileList();
            }).catch((error) => {
                kaung.error(error.message)
            })
        }
    }
}
</script>

<style scoped>
.article-pusher {
    padding: 20px;
}

.article-pusher :deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 90px;
    height: 90px;
}

.article-pusher :deep(.el-upload--picture-card) {
    width: 90px;
    height: 90px;
    line-height: 90px;
}

.article-pusher :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
    width: 100%;
    height: 100%;
}

.article-pusher :deep(.el-upload-list__item-actions span + span) {
    margin-left: 3px;
}
</style>